import React from "react";

export default function Spinner(){
	return (
		<div className="ocdb-spinner">
			<div></div>
			<div></div>
		</div>
	)
}
